import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import Template from './template.vue';
import AuthMixin from '@/mixins/AuthMixin';
import { Usuario } from '@/store/modules/usuario/types';
import UsuarioForm from '@/components/UsuarioForm/component';
import { mapGetters, mapState } from 'vuex';

const namespace: string = 'usuarioModule';

@Component({
  mixins: [Template, AuthMixin],
  components: { UsuarioForm },
  computed: mapState(['loading']),
})
export default class Usuarios extends Vue {

  // tslint:disable-next-line: ban-types
  @Action('getUsuarios', { namespace }) private getUsuarios!: Function;
  @Getter('usuarios', { namespace }) private usuarios!: Usuario[];

  @State('error', { namespace }) private errorLoadingUsuarios!: boolean;
  @State('errorMessage', { namespace }) private errorMessage!: string;

  private buscador: string = '';
  private dialog: boolean = false;
  private usuarioSel: Partial<Usuario> = {};
  private agregando: boolean = false;
  private gridHeaders: any = [
    { text: 'Nombre', value: 'name' },
    { text: 'Nombre usuario', value: 'username' },
    { text: 'Correo', value: 'email' },
    { text: 'Rol', value: 'rol' },
    { text: 'Estatus', value: 'estatus' },
    { text: 'Acciones', value: 'id', sortable: false },
  ];
  private gridPags: any = {
    rowsPerPage: 10,
  };

  private mounted() {
    // this.$store.getters['loading']
    this.getUsuarios();
  }

  private editaUsuario(usuario: Usuario) {
    const nvo: Partial<Usuario> = {};
    Object.assign(nvo, usuario);
    this.usuarioSel = nvo;
    this.agregando = false;
    this.dialog = true;
  }

  private async eliminaUsuario(usuario: Usuario) {
    // const res = await this.$dialog.confirm({
    //   text: '¿Confirma que desea eliminar el usuario?',
    //   title: 'Eliminando usuario',
    //   type: 'warning',
    //   actions: {
    //     false: 'No',
    //     true: {
    //       color: 'red',
    //       text: 'Sí'
    //     }
    //   }
    // });
    // if (res) {
    //   this.deleteUsuario(usuario._id);
    // }
  }

  private agregarUsuario() {
    this.usuarioSel = {
      estatus: 'A',
    };
    this.agregando = true;
    this.dialog = true;
  }

  private cerrarForma(ok: boolean) {
    this.dialog = false;
  }
}
